var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2383 10C13.2383 11.3807 12.119 12.5 10.7383 12.5C9.35759 12.5 8.23828 11.3807 8.23828 10C8.23828 8.61925 9.35759 7.5 10.7383 7.5C12.119 7.5 13.2383 8.61925 13.2383 10Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.739 4.16675C7.00758 4.16675 3.84901 6.61915 2.78711 10.0001C3.84899 13.381 7.00758 15.8334 10.739 15.8334C14.4703 15.8334 17.6289 13.381 18.6908 10.0001C17.6289 6.61917 14.4703 4.16675 10.739 4.16675Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgView);
export default __webpack_public_path__ + "static/media/View.d57a56b7aef1283fcbd2f6f4e85df19a.svg";
export { ForwardRef as ReactComponent };